import { mdiProgressClock, mdiBatteryAlert, mdiQrcode } from '@mdi/js'
import Icon from '@mdi/react'
import { Tooltip } from 'antd'
import { Colors } from 'constants/Colors'
import { Translate } from 'lang'

const IconsList = {
  waiting_identification: {
    icon: mdiQrcode,
    color: Colors.green,
  },
  waiting_tests: {
    icon: mdiProgressClock,
    color: Colors.waiting,
  },
  defective: {
    icon: mdiBatteryAlert,
    color: Colors.danger,
  },
}

const StatusIcon = ({ value, style }) => {
  if (!value) return '-'
  return (
    <Tooltip title={Translate({ messageKey: `${value}` })}>
      <div>
        <Icon path={IconsList[value].icon} color={IconsList[value].color} size={1} style={style} />
      </div>
    </Tooltip>
  )
}
export default StatusIcon
